import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'reactstrap';

import { modelOf } from '../../../../prop-types';
import CheckoutStore from '../../../../store/CheckoutStore';
import { fieldTypeLabel } from '../../../../util/formLabels';
import FormGroupField from '../../../form/FormGroupField';

const CheckoutOrderExtrasForm = ({ checkoutStore, onOrderUpdate }) => {
  const { cancelOrder, order } = checkoutStore;

  const handleExtraFieldOnBlur = () => onOrderUpdate({ withoutTimer: true });

  const handleExtraFieldChange = (e, fieldId) => {
    cancelOrder();
    const field = order.extra_fields.get(fieldId);

    field.setValue(e.target.value);
  };

  return (
    <div className="CheckoutOrderExtrasForm">
      <Row>
        {order.extraFields.map((field) => (
          <Col key={field.id}>
            <FormGroupField
              field={field}
              fieldName={`${fieldTypeLabel.EXTRA_MESSAGE}--${field.id}`}
              formName={'checkout'}
              floatingLabel
              label={field.name}
              type={field.type.toLowerCase()}
              onChange={(e) => handleExtraFieldChange(e, field.id)}
              onBlur={handleExtraFieldOnBlur}
              onFocus={cancelOrder}
              rows={2}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

CheckoutOrderExtrasForm.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
  onOrderUpdate: PropTypes.func.isRequired,
};

export default inject('checkoutStore')(observer(CheckoutOrderExtrasForm));
